import * as React from "react";
import { DatePicker } from "../../../../../../react-core/Datepicker/DatePicker";
import { FormComponent } from "../../../../../../react-core/Html/FormComponent";
import { SelectEditor } from "../../../../../../react-core/Html/SelectEditor";
import { addYears, addDays } from "../../../../../../react-core/utils/date";
import { JsonDateParser } from "../../../../../../react-core/Utils/JsonDateParser";
import { CompanyDetailSort } from "../../../../../../Wrap/Constants/Enums/Domain/CompanyDetailSort";
import { FirmType } from "../../../../../../Wrap/Constants/Enums/Domain/FirmType";
import { NetworkType } from "../../../../../../Wrap/Constants/Enums/Network/NetworkType";
import { CompanySummary } from "../../../../../../Wrap/Models/Models/Company/CompanySummary";
import { NetworkHistoryModel } from "../../../../../../Wrap/Models/Models/Network/NetworkHistoryModel";
import { CompanyWizardAction } from "../../../../../Admin/Company/CompanyWizard/Actions/CompanyWizardAction";
import { CompanyStore } from "../../../../../Admin/Company/CompanyWizard/Stores/Variable";
import { NetworkAction } from "../../../../../Admin/Network/Actions/NetworkAction";
import { NetworkStore } from "../../../../../Admin/Network/Stores/Variable";
import { datePickerOptions } from "../../../Clients/Common/Resource/Contents";
import { DefaultMaximum, ReportType, ReportTypeArray, ReportTypeMap } from "../Resource/Contents";
import { ReportSearchResultTable } from "./ReportSearchResultTable";
import { BackOfficeProviderBulkValuationReportStore } from "../../../../../Admin/Company/CompanyWizard/Stores/Variable";
import { BackOfficeProviderBulkValuationReport } from "../../../../../../Wrap/Models/Models/BackOfficeIntegration/BackOfficeProviderBulkValuationReport";
import { ClientAccountStore, UserStore } from "../../../../Stroes/Variable";
import { User } from "../../../../../../Wrap/Models/Models/User/User";

interface IBackOfficeProps {}

interface IBackOfficeState {
    BulkValuationReport: BackOfficeProviderBulkValuationReport[];
    BulkValuationReportMatched: BackOfficeProviderBulkValuationReport[];
    userInfo: User;
    isLoading: boolean;
    reportType: ReportType;
    network: NetworkHistoryModel;
    firm: CompanySummary;
    startDate: Date;
    endDate: Date;
    availableNetworks: NetworkHistoryModel[];
    availableFirms: CompanySummary[];
}

export class BackOffice extends FormComponent<IBackOfficeProps, IBackOfficeState> {
    constructor(props: any) {
        super(props);
        this.state = {
            BulkValuationReport: null,
            BulkValuationReportMatched: null,
            userInfo: UserStore.getUserInfo(),
            isLoading: false,
            reportType: ReportType.BulkValuations,
            network: null,
            firm: null,
            startDate: null,
            endDate: null,
            availableFirms: [],
            availableNetworks: [],
        };
        this.subscribeToStore(NetworkStore, () => this.onNetworkStoreChange());
        this.subscribeToStore(CompanyStore, () => this.onCompanyWizardStoreChange());
        this.subscribeToStore(BackOfficeProviderBulkValuationReportStore, () =>
            this.onBulkValuationReportStoreChange()
        );
    }

    componentDidMount() {
        const networkQuery = { NetworkType: NetworkType.Network, Min: 1, Max: DefaultMaximum };
        NetworkAction.getNetwork(networkQuery);
        this.updateFirm(null);
    }

    private updateFirm(network: string) {
        const companySearchQuery = {
            CompanyId:
                this.state.userInfo != null && this.state.userInfo.IsAdviser && this.state.userInfo.Company != ""
                    ? this.state.userInfo.Company
                    : null,
            FirmType: FirmType.All,
            SortDescending: false,
            Start: 1,
            Count: DefaultMaximum,
            OrderBy: CompanyDetailSort.CompanyName,
            Network: network,
            IncludeInactive:false
        };
        if (this.state.userInfo != null && this.state.userInfo.IsAdviser && this.state.userInfo.Company === "") {
            return;
        }
        CompanyWizardAction.getFirm(companySearchQuery);
    }

    private onNetworkStoreChange() {
        const data = NetworkStore.getData();
        this.setState({ availableNetworks: data?.networks || [] });
    }

    private onCompanyWizardStoreChange() {
        const data = CompanyStore.getData();
        this.setState({ availableFirms: data?.PageOfResults || [] });
        this.updateNetworkCompanyAvailableValue();
        this.updateNetworkCompanyDefaultValue();
    }

    private updateNetworkCompanyAvailableValue() {
        // adviser
        if (this.state.userInfo != null && this.state.userInfo.IsAdviser) {
            if (this.state.userInfo.Company != "") {
                const availableFirm = this.state.availableFirms.filter(
                    (x) => x.CompanyCode === this.state.userInfo.Company
                );
                this.setState({ availableFirms: availableFirm });
                if (availableFirm[0]?.NetworkName != null) {
                    const availableNetwork = this.state.availableNetworks.filter(
                        (n) => n.NetworkName === availableFirm[0].NetworkName
                    );
                    this.setState({ availableNetworks: availableNetwork });
                } else {
                    this.setState({ availableNetworks: [] });
                }
            } else {
                this.setState({ availableNetworks: [] });
                this.setState({ availableFirms: [] });
            }
        }
    }

    private updateNetworkCompanyDefaultValue() {
        if (this.state.userInfo != null && this.state.userInfo.Company != "" && this.state.availableFirms.length > 0) {
            const firmDefault = this.state.availableFirms.find((f) => f.CompanyCode === this.state.userInfo.Company);
            this.setState({ firm: firmDefault });
            if (firmDefault?.NetworkName != null) {
                const networkDefault = this.state.availableNetworks.find(
                    (n) => n.NetworkName === firmDefault.NetworkName
                );
                this.setState({ network: networkDefault });
            }
        }
    }

    private onBulkValuationReportStoreChange() {
        const data = BackOfficeProviderBulkValuationReportStore.getData();
        this.setState({ BulkValuationReport: data ?? [], isLoading: false });
        this.setState({ BulkValuationReportMatched: data?.filter((x) => x.DocumentId != 0) });
    }

    private renderFilter() {
        const { reportType, network, firm, startDate, endDate, availableNetworks, availableFirms } = this.state;

        return (
            <>
                <div className="row">
                    <div className="col-12 col-sm-4">
                        <SelectEditor
                            options={ReportTypeArray}
                            getText={(v) => {
                                return ReportTypeMap[v];
                            }}
                            placeholder="Please select"
                            label="Report type"
                            selected={reportType}
                            required={"Please select report type"}
                            onChange={(v) => {
                                this.setState({ reportType: v });
                            }}
                        />
                    </div>
                    <div className="col-12 col-sm-4">
                        <SelectEditor
                            options={[null].concat(availableNetworks)}
                            getText={(option) => {
                                return option != null ? option.NetworkName : "All";
                            }}
                            label={"Network"}
                            selected={network}
                            onChange={(v) => {
                                this.onNetworkSelectionChange(v);
                                this.setState({ network: v });
                            }}
                        />
                    </div>
                    <div className="col-12 col-sm-4">
                        <SelectEditor
                            options={[null].concat(availableFirms)}
                            getText={(option) => {
                                return option != null ? option?.CompanyName : "All";
                            }}
                            label={"Firm"}
                            selected={firm}
                            onChange={(v) => {
                                this.setState({ firm: v });
                            }}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-4 col-12">
                        <DatePicker
                            label="Requested between"
                            selected={startDate}
                            onChange={(v) => {
                                this.setState({ startDate: v });
                            }}
                            atLeast={{
                                value: addYears(new Date(), -7),
                                errorMessage: "Please select a more recent date",
                            }}
                            atMost={{
                                value: addDays(new Date(), -1),
                                errorMessage: "Please select a date in the past",
                            }}
                            alwaysValidateOnUpdate={false}
                            {...datePickerOptions}
                            required="Please select start date"
                        />
                    </div>
                    <div className="col-sm-4 col-12">
                        <DatePicker
                            label="And"
                            selected={endDate}
                            onChange={(v) => {
                                this.setState({ endDate: v });
                            }}
                            atLeast={{
                                value: startDate ? startDate : addYears(new Date(), -7),
                                errorMessage: "Please select a more recent date",
                            }}
                            atMost={{
                                value: startDate
                                    ? addYears(startDate, 1).getTime() > new Date().getTime()
                                        ? new Date()
                                        : addYears(startDate, 1)
                                    : new Date(),
                                errorMessage: "Please select a date in the past",
                            }}
                            alwaysValidateOnUpdate={false}
                            {...datePickerOptions}
                            required="Please select end date"
                        />
                    </div>
                    <div className="col-sm-4 col-12">
                        <button className="btn primary mt-30" onClick={() => this.onClickSearch()}>
                            Go
                        </button>
                    </div>
                </div>
            </>
        );
    }

    private onNetworkSelectionChange(network: NetworkHistoryModel) {
        this.updateFirm(network?.Network);
    }

    private onClickSearch() {
        if (this.isValid()) {
            //1 : Bulk Contract Enquiry, 2 : Bulk Transaction History
            const bulkFileTypeId = this.state.reportType == ReportType.BulkValuations ? 1 : 2;
            const networkId = this.state.network === null ? 0 : this.state.network.NetworkId;
            let companyCode = this.state.firm === null ? null : this.state.firm.CompanyCode;
            if (
                this.state.userInfo != null &&
                this.state.userInfo.IsAdviser &&
                this.state.network === null &&
                this.state.firm === null
            ) {
                if (this.state.userInfo.Company != "") {
                    companyCode = this.state.userInfo.Company;
                } else {
                    this.setState({ BulkValuationReport: [] });
                    this.setState({ BulkValuationReportMatched: [] });
                    return;
                }
            }
            this.setState({ isLoading: true });
            CompanyWizardAction.getBackOfficeProviderBulkValuationReports(
                bulkFileTypeId,
                networkId,
                companyCode,
                JsonDateParser.toJsonDateNoOffset(this.state.startDate),
                JsonDateParser.toJsonDateNoOffset(this.state.endDate)
            );
        }
    }

    private renderTable() {
        return (
            <ReportSearchResultTable data={this.state.BulkValuationReportMatched} isLoading={this.state.isLoading} />
        );
    }

    public render(): JSX.Element {
        return (
            <div>
                <h1 className="page-heading">Filter Report History</h1>
                {this.renderFilter()}
                {this.renderTable()}
            </div>
        );
    }
}
